import { isMobileClause } from '@gonfalon/clauses/isMobileClause';

import type { Rule } from './types';

// A mobile rule is where the first clause is a mobile clause
export const isMobileRule = ({ clauses }: Rule) =>
  clauses && clauses.length > 0 && clauses[0] && isMobileClause(clauses[0]);
